import { createFileRoute } from "@tanstack/react-router";
import GrantsRoute from "@/pages/GrantsRoute";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/resources/subsidies")({
  head: () => pageHead("grants", "en", { links: false }),
  component: GrantsRoute,
});
